// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserProfileJoinCallButton__active-call-button-bbb95f {
  margin-inline-start: 16px;
  width: 40px;
}`, "",{"version":3,"sources":["webpack://./src/main/Profile/UserProfile/UserProfileJoinCallButton/UserProfileJoinCallButton.m.css"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,WAAA;AACF","sourcesContent":[".active-call-button {\n  margin-inline-start: 16px;\n  width: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"active-call-button": `UserProfileJoinCallButton__active-call-button-bbb95f`,
	"activeCallButton": `UserProfileJoinCallButton__active-call-button-bbb95f`
};
module.exports = ___CSS_LOADER_EXPORT___;
